export default __webpack_public_path__ + "static/media/amalganation.17134fa0.jpg";